import React, { useEffect, useRef, useState } from "react";
import { Divider, Form, Input, InputNumber, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import svg166 from "../../../../assets/svg/svg166.svg";
import { cashConverter } from "../../../../utils";

const { TextArea } = Input;
const BalanceModal = ({ open, handleCancel, handleFetchData, prodd,prodd1 }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);

  const onFinish = async (data) => {};

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue(prodd);
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Balance for ${prodd?.apbNumber} - ${prodd?.apbType}`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        maskClosable={false}
        width={550}
      >
        <div className="pb-[5rem]">
          <div className="flex justify-between items-center mt-[0.81rem]">
            <span className="text-[#7A7493] font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
              Utility Balance
            </span>
            <span className="text-[#2F9461] font-lexendS text-[1rem] font-[600] leading-[1.5rem]">
              {cashConverter(prodd1?.utilityAmount)}
            </span>
          </div>

            <div className="flex justify-between items-center mt-[0.81rem]">
            <span className="text-[#7A7493] font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
              Working Balance
            </span>
            <span className="text-[#2F9461] font-lexendS text-[1rem] font-[600] leading-[1.5rem]">
              {cashConverter(prodd1?.workingAmount)}
            </span>
          </div>

          {/* Due Date */}
          <div className="flex justify-between items-center mt-[1.13rem]">
            <span className="text-[#7A7493] font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
              Due Date
            </span>
            <span className="text-[#000] font-lexendS text-[0.875rem] font-[500] leading-[1.25rem]">
              {new Date().toLocaleDateString('en-GB')}
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default BalanceModal;
